import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/client/lib/page-title";
import { ensureTenantData } from "@/client/lib/session";
import { NotesIndex } from "@/features/notes/components/notes-index";
import { notesQuery } from "@/features/notes/notes-query";
import { notesSearch } from "@/features/notes/search";

export const Route = createFileRoute("/_authenticated/$slug/notes/")({
  head: async ({ match }) => {
    const { notesCopy } = await import("@/features/notes/copy");
    return {
      meta: [{ title: pageTitle(notesCopy.title, match.context.companyName) }],
    };
  },
  validateSearch: notesSearch,
  loader: ({ context }) => ensureTenantData(context.queryClient, notesQuery),
  component: Notes,
});

function Notes() {
  const { slug } = Route.useParams();
  const { q } = Route.useSearch();
  const { companyTimezone } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const { data: notes } = useSuspenseQuery(notesQuery);
  return (
    <NotesIndex
      slug={slug}
      notes={notes}
      q={q}
      timeZone={companyTimezone}
      // Replaced, so Back leaves Notes rather than stepping through each word typed.
      onSearch={(next) => navigate({ search: { q: next }, replace: true })}
    />
  );
}
